<template>
  <div
    class="bg-white border-gray-200 border-b"
    :class="{ 'bg-brand-50': selected }"
  >
    <div
      @click="emit('selected', role)"
      class="flex items-center cursor-pointer gap-2 px-2 py-4 hover:bg-gray-50 border-gray-200"
    >
      <div
        class="p-1.5 mr-0.5 hover:bg-gray-100 rounded-xs"
        @click.stop="emit('toggle', role)"
      >
        <div class="h-5 w-5">
          <div v-if="permissionGroups.length > 0">
            <ChevronDownIcon
              v-if="open"
              class="text-gray-900"
              aria-hidden="true"
            />
            <ChevronRightIcon v-else class="text-gray-900" aria-hidden="true" />
          </div>
        </div>
      </div>
      <div class="flex flex-col gap-0">
        <p class="text-sm font-medium m-0 text-gray-700">
          {{ role.name }}
        </p>
        <p class="text-xs font-lighter m-0 text-gray-600">
          {{ role.description }}
        </p>
      </div>
    </div>
    <div v-if="open">
      <PermissionGroup
        v-for="group in permissionGroups"
        :key="group.id"
        :value="form.permissions"
        :permissionGroup="group"
        :disabled="disabled"
        @change="handleUpdate"
      />
    </div>
  </div>
</template>

<script setup>
import { ChevronDownIcon, ChevronRightIcon } from "@heroicons/vue/20/solid";
import { useForm, usePage } from "@inertiajs/vue3";
import PermissionGroup from "@/Tailwind/Components/Settings/Permissions/PermissionGroup.vue";
import { computed, inject } from "vue";

const props = defineProps({
  role: {
    type: Object,
    required: true,
  },
  selected: {
    type: Boolean,
    default: false,
  },
  open: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const { applyPermissionsOrder } = inject("permissions");

const emit = defineEmits(["selected", "update", "toggle"]);

// Use an inertia form so we can use the generic update method in the parent component
const form = useForm({
  name: props.role.name,
  description: props.role.description,
  permissions: props.role.permissions.map((permission) => permission.id),
});

const permissionGroups = computed(() => {
  return usePage().props.permission_groups?.map((group) =>
    applyPermissionsOrder(group)
  );
});

const handleUpdate = (permissions) => {
  form.permissions = permissions;

  emit("update", form);
};
</script>
